"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _polished = require("polished");
var _Question = require("../Question.styled");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var GapQuestion = function GapQuestion(_ref) {
  var question = _ref.question,
    label = _ref.label,
    onChange = _ref.onChange;
  var gapRef = (0, _react.useRef)(null);
  var controlledValue = (0, _react.useMemo)(function () {
    var _question$answer;
    return (_question$answer = question.answer) !== null && _question$answer !== void 0 ? _question$answer : [];
  }, [question.answer]);
  var controlledQuestion = (0, _react.useMemo)(function () {
    return question;
  }, [question]);
  var onGapChange = function onGapChange(e, option) {
    var _tempValues = Object.assign([], controlledValue);
    var gap = _tempValues.findIndex(function (_) {
      return _.target === option.gap;
    });
    if (gap > -1) {
      _tempValues[gap] = {
        target: option.gap,
        answer: e.target.value
      };
    } else {
      _tempValues.push({
        target: option.gap,
        answer: e.target.value
      });
    }
    onChange(_tempValues);
  };
  var splittedContent = controlledQuestion.parsed_content.split(/\$\$[0-9]*/g);
  var getDropdown = function getDropdown(index) {
    var options = controlledQuestion.options[index];
    var answer = controlledQuestion.answer && controlledQuestion.answer.find(function (_) {
      return _.target === options.gap;
    });
    return /*#__PURE__*/_react["default"].createElement("select", {
      className: "gap-select",
      onChange: function onChange(e) {
        return onGapChange(e, options);
      },
      value: answer === null || answer === void 0 ? void 0 : answer.answer,
      title: options.gap.toString()
    }, !answer && /*#__PURE__*/_react["default"].createElement("option", {
      selected: true
    }), options.choices.map(function (value) {
      return /*#__PURE__*/_react["default"].createElement("option", {
        value: value
      }, value);
    }));
  };
  return /*#__PURE__*/_react["default"].createElement(_Question.QuestionContentWrapper, null, /*#__PURE__*/_react["default"].createElement(StyledContainer, null, splittedContent.map(function (_, index) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledContainer, {
      ref: gapRef,
      dangerouslySetInnerHTML: {
        __html: _
      }
    }), index < splittedContent.length - 1 && /*#__PURE__*/_react["default"].createElement(StyledContainer, null, getDropdown(index)));
  })));
};
var _default = GapQuestion;
exports["default"] = _default;
var StyledContainer = _styledComponents["default"].span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t.gap-select {\n\t\tborder: 1.5px solid ", ";\n\t\tfont-weight: bold;\n\t\tborder-radius: 5px;\n\t\tbackground-color: #fff;\n\n\t\tcolor: ", ";\n\t\tpadding: 6px 10px;\n\t\tpadding-right: 20px;\n\t\toutline: 1px solid ", ";\n\t\tposition: relative;\n\t\tmargin-bottom: 0.5rem;\n\t\toption {\n\t\t\tpadding: 3px 12px;\n\t\t\tborder: 0;\n\t\t\tcolor: #000;\n\t\t\tfont-weight: bold;\n\t\t}\n\t\toption:checked {\n\t\t\tbackground: rgba(0, 0, 0, 0.08);\n\t\t}\n\t}\n"])), function (props) {
  return props.theme.colors.purple;
}, function (props) {
  return props.theme.colors.purple;
}, function (props) {
  return (0, _polished.rgba)(props.theme.colors.purple, 0.5);
});